export default __webpack_public_path__ + "static/media/seo-internal-links.7a1bcc72.svg";